export default "__VITE_ASSET__C1AWcOoE__"